import React, { useState, useEffect, useRef } from "react";
import ServicesSection from "./ServicesSection";
import marketing from "../../assets/images/services/marketing.png";
import socialMedia from "../../assets/images/services/socialMedia.png";
import branding from "../../assets/images/services/branding.png";
import production from "../../assets/images/services/production.png";
import web from "../../assets/images/services/web.png";
import analytics from "../../assets/images/services/analytics.png";

import { useStateContext } from "../../context/ContextProvider";

const servicesList = [
  {
    heading: "Digital Marketing Solutions",
    text: "Drive Measurable Growth & Deepen Engagement",
    img: marketing,
    categories: ["Strategic Planning", "SEO & SEM"],
  },
  {
    heading: "Social Media Marketing",
    text: "Amplify Your Brand’s Online Impact",
    img: socialMedia,
    categories: ["Paid Campaigns", "Creative Content", "Platform Management"],
    flip: true,
  },
  {
    heading: "Branding Services",
    text: "Build a Distinctive & Memorable Identity",
    img: branding,
    categories: ["Visual Identity", "Brand Storytelling", "Strategic Branding"],
  },
  {
    heading: "Creative Production",
    text: "Engage & Inspire with Stunning Content",
    img: production,
    categories: ["Video Production", "Graphic Design", "Interactive Content"],
    flip: true,
  },
  {
    heading: " Web Development ",
    text: "Maximize Your Online Potential",
    img: web,
    categories: ["Website Design", "UI/UX", "E-Commerce"],
  },
  {
    heading: " Data Analytics ",
    text: "Make Informed Decisions with Actionable Insights",
    img: analytics,
    categories: [
      "Performance Analysis",
      "Actionable Reports",
      "Behavior Insight",
    ],
    flip: true,
  },
];

const Services = () => {
  const { isMobile, MARKER } = useStateContext();
  const [activeService, setActiveService] = useState(null);
  const serviceRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.dataset.index, 10);
            setActiveService(index);
          }
        });
      },
      {
        root: null,
        threshold: 0.3,
      }
    );
    serviceRefs.current.forEach((ref) => ref && observer.observe(ref));

    return () => {
      serviceRefs.current.forEach((ref) => ref && observer.unobserve(ref));
    };
  }, []);

  return (
    <div>
      {/* HALF CIRCLES */}
      <div className="absolute bottom-10 right-[7%] flex items-center justify-end">
        <div
          className="relative w-[100px] h-[200px] lg:w-[150px] lg:h-[300px] rounded-s-full"
          style={{
            backgroundImage:
              "linear-gradient(to bottom right, var(--secondary), var(--primary)",
            boxShadow:
              "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
            zIndex: -1,
          }}
        ></div>
        <div
          className="relative w-[100px] h-[200px] lg:w-[150px] lg:h-[300px] rounded-s-full"
          style={{
            backgroundImage:
              "linear-gradient(to bottom right, var(--secondary), var(--primary)",
            boxShadow:
              "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
            zIndex: -1,
          }}
        ></div>
      </div>

      {/* CONTAINER */}
      <div className="w-full padding-container my-5 py-5">
        <h1 className="subhero-text uppercase font-bold text-end">
          Services
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-4 my-5 py-5">
          <div className="col-span-1"></div>
          <div className="col-span-1 md:col-span-2">
            <p className="text-[var(--l-gray)] text-sm text-start">
              With DODEAL, your goals are our mission. From groundbreaking
              marketing campaigns to seamless tech integrations, we provide the
              tools, insights, and support needed to navigate challenges and
              deliver impactful results that resonate with your audience.
            </p>
          </div>
        </div>

        <div className="w-full flex flex-col items-center justify-center gap-5 py-5 my-5">
          {/* SERVICES */}
          {servicesList?.map((service, index) => (
            <ServicesSection
              key={index}
              ref={(el) => (serviceRefs.current[index] = el)}
              data-index={index}
              service={{
                ...service,
                isActive: activeService === index,
              }}
              index={index}
              setActiveService={setActiveService}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
